import { render, staticRenderFns } from "./TableConfirm.vue?vue&type=template&id=33c95d0e&scoped=true"
import script from "./TableConfirm.vue?vue&type=script&lang=js"
export * from "./TableConfirm.vue?vue&type=script&lang=js"
import style0 from "./TableConfirm.vue?vue&type=style&index=0&id=33c95d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c95d0e",
  null
  
)

export default component.exports